import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { Label } from 'reactstrap'



export default function Footer() {
  const [scrollPercentage, setScrollPercentage] = useState(0);
  const [isDisclaimer, setIsDisclaimer] = useState(false);
  useEffect(() => {
    const updateScrollPercentage = () => {
      const scrollPx = document.documentElement.scrollTop;
      const winHeightPx =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      const scrolled = (scrollPx / winHeightPx) * 100;

      setScrollPercentage(scrolled);
    };

    window.addEventListener('scroll', updateScrollPercentage);

    return () => {
      window.removeEventListener('scroll', updateScrollPercentage);
    };
  }, []);

  useEffect(() => {
    let time = null;
    const getData = async () => {
      const item = await localStorage.getItem('policy');
      console.log('policy from storage', item);
      if (!item)
        time = setTimeout(() => {
          setIsDisclaimer(true)
        }, 3000);
    }
    getData();
    return () => clearTimeout(time);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setIsDisclaimer(true);
      } else {
        setIsDisclaimer(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup the event listener
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  const handleOkayDisclaimer = () => {
    setIsDisclaimer(false);
    localStorage.setItem('policy', 'agreed');
  }

  return (
    <>
      <div className='footer-section bottom_footer'>
        <div className='container'>
          <div className='row top'>
            <div className='col-lg-3 col-md-6'>
              <div className='f-logo'>
                <img src={require('../assets/images/f-logo-check.webp')} alt='logo' />
              </div>
            </div>
            <div className='col-lg-3 col-md-6'>
              <div className='footer-mail'>
                <p className='wow-fadeUP'><Link to="mailto:info@codezix.com"><i class="fa fa-envelope-o" aria-hidden="true"></i> &nbsp;info@codezix.com</Link></p>
              </div>
            </div>
            <div className='col-lg-3 col-md-6'>
              <div className='footer-mail'>
                <p className='wow-fadeUP'><Link to="tel:+19177307436"><i class="fa fa-phone" aria-hidden="true"></i> &nbsp;+1-917-730-7436</Link></p>
              </div>
            </div>
            <div className='col-lg-3 col-md-6'>
              <div className='footer-social'>
                <div className='social-icons'>
                  <div className='facebook'>
                    <Link to="/" target='_blank'><i class="fa-brands fa-facebook"></i></Link>
                  </div>
                  <div className='insta'>
                    <Link to="/"><i class="fa-brands fa-instagram"></i></Link>
                  </div>
                  <div className='insta'>
                    <Link to="https://www.linkedin.com/company/codezix/" target='_blank'><i class="fa-brands fa-linkedin"></i></Link>
                  </div>
                  <div className='insta'>
                    <Link to="/" target='_blank'> <i class="fa-brands fa-twitter"></i></Link>
                  </div>
                  <div className='insta'>
                    <Link to="/" target='_blank'> <i class="fa-brands fa-youtube"></i></Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='divider-line'></div>
          <div className='row mb-4'>
            <div className='col-lg-3'>
              <div className='footer-item'>
                <h3>Salesforce Services</h3>
                <div className='footer-item-link pt-4'>
                  <Link to="/salesforce/consulting"><p>Salesforce Consulting</p></Link>
                  <Link to="/salesforce/implementation"><p>Salesforce Implementation</p></Link>
                  <Link to="/salesforce/maintenance"><p>Salesforce Maintenance</p></Link>
                  <Link to="/salesforce/salesforce/support"><p>Salesforce Support</p></Link>
                  <Link to="/salesforce/managed"><p>Salesforce Managed</p></Link>
                </div>
              </div>
            </div>
            <div className='col-lg-3'>
              <div className='footer-item'>
                <h3>Technologies</h3>
                <div className='footer-item-link pt-4'>
                  <Link to="/salesforce/sales-cloud"><p>Sales Cloud</p></Link>
                  <Link to="/salesforce/service-cloud"><p>Services Cloud</p></Link>
                  <Link to="/salesforce/marketing-cloud"><p>Marketing Cloud</p></Link>
                  <Link to="/salesforce/cpq"><p>Salesforce CPQ</p></Link>
                  <Link to="/salesforce/community-cloud"><p> Community Cloud</p></Link>
                </div>
              </div>
            </div>
            <div className='col-lg-3'>
              <div className='footer-item'>
                <h3>Useful Links</h3>
                <div className='footer-item-link pt-4'>
                  <Link to="/about"><p>About Us</p></Link>
                  <Link to="/salesforce"><p>Salesforce</p></Link>
                  <Link to="/contact"><p>Get In Touch</p></Link>
                  <Link to="/career"><p>Careers</p></Link>
                  <Link to="/"><p>Privacy Policy</p></Link>
                </div>
              </div>
            </div>
            <div className='col-lg-3'>
              <div className='footer-item'>
                <h3>Resources</h3>
                <div className='footer-item-link pt-4'>
                  <Link to="/"><p>Articles & Blogs</p></Link>
                  <Link to="/case-study"><p>Case Studies</p></Link>
                </div>
              </div>
            </div>
          </div>
          <div className='divider-line'></div>
          <div className='row mb-3'>
            <div className='col-md-3'>
              <div className='footer-location'>
                <div className='location'>
                  <i class="fa fa-map-marker" aria-hidden="true"></i>&nbsp;&nbsp;
                  <img src={require('../assets/images/us (1).webp')} alt='' />&nbsp;&nbsp;
                  <h3>United State</h3>
                </div>
                <p className='prose-lg mt-4'>
                  222 W Merchandise Mart Plaza floor 12 suite 1212, Chicago, IL 60654, United States</p>
                {/* <div className='location'>
                  <i class="fa fa-phone" aria-hidden="true"></i>&nbsp;&nbsp;
                  <h3>+1-347-746-2125</h3>
                </div>
                <div className='location mt-2'>
                  <i class="fa fa-envelope-o" aria-hidden="true"></i>&nbsp;&nbsp;
                  <h3>sales@codezix.com</h3>
                </div> */}
              </div>
            </div>

            <div className='col-md-9'>
              <div className='footer-certification'>
                <div align="center" class="footerCertNew">
                  <br />
                  <a target="blank" href="#"><img src={require('../assets/images/footer/partner-1.webp')} alt="" /></a>
                  <a target="blank" href="#"><img src={require('../assets/images/footer/partner-2.webp')} alt="" /></a>
                  <a target="blank" href="#"><img src={require('../assets/images/footer/partner-3.webp')} alt="" /></a>
                  <a target="blank" href="#"><img src={require('../assets/images/footer/partner-4.webp')} alt="" /></a>
                  <a target="blank" href="#"><img src={require('../assets/images/footer/partner-5.webp')} alt="" /></a>
                  <a target="blank" href="#"><img src={require('../assets/images/footer/partner-6.webp')} alt="" /></a>
                  <a target="blank" href="#"><img src={require('../assets/images/footer/partner-7.webp')} alt="" /></a>
                  <a target="blank" href="#"><img src={require('../assets/images/footer/partner-8.webp')} alt="" /></a>
                  <a target="blank" href="#"><img src={require('../assets/images/footer/partner-9.webp')} alt="" /></a>
                </div>
              </div>
            </div>
          </div>
          <div className='divider-line'></div>
          <div className='col-lg-12'>
            <div className='footer-copyright'>
              <p className='wow fadeUp'>Copyright © 2025 Codezix. All Rights Reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}


